import {Injectable} from '@angular/core';
import {DcpDataService} from './dcp-data.service';
import {CxEvent, Product} from '@spartacus/core';
import {CurrentProductService, ProductDetailsPageEvent} from '@spartacus/storefront';
import {first, map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {DcpPageHitDataService} from './dcp-page-hit-data.service';
import {AdobeTrackingData} from './models/adobe-tracking-data';
import {DcpProductUtilitiesService} from '../../product/services/dcp-product-utilities.service';
import {DataTrackingService} from './data-tracking.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class DcpProductDetailsPageHitDataService extends DcpDataService<AdobeTrackingData> {

  constructor(
    private currentProductService: CurrentProductService,
    private pageHitDataService: DcpPageHitDataService,
    private productUtilitiesService: DcpProductUtilitiesService,
    private dataTrackingService: DataTrackingService,
  ) {
    super();
  }

  public getData(event: CxEvent): Observable<AdobeTrackingData> {
    if (!(event instanceof ProductDetailsPageEvent)) {
      return of(undefined);
    }
    return this.currentProductService.getProduct().pipe(
      first(),
      map(product => product ? this.fillData(event, product) : undefined),
      untilDestroyed(this)
    );
  }

  public fillData(event: ProductDetailsPageEvent, product: Product, data?: AdobeTrackingData): AdobeTrackingData {
    if (!data) {
      data = {
        events: {},
      };
    }
    data = this.pageHitDataService.fillData(event.navigation, data);
    data.events.productView = true;
    data.ecommerce = {
      products: [
        {
          ID: this.productUtilitiesService.getProductId(product),
          name: product.name,
          findingMethod: this.dataTrackingService.getFindingMethod(),
          partnerName: product.vendor && product.vendor.name,
        }
      ],
    };
    return data;
  }
}
